/* eslint-disable no-param-reassign */
export function PrepareData(d) {
  // https://www.abs.gov.au/statistics/people/population/national-state-and-territory-population/latest-release
  const nswPopulation = 6395412;
  const vicPopulation = 5225587;
  const qldPopulation = 4025398;
  const saPopulation = 1403585;
  const waPopulaiton = 2065774;
  const tasPopulation = 429238;
  const ntPopulation = 184749;
  const actPopulation = 335330;

  function round(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  d.AIR_NSW_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_NSW_18_PLUS_THIRD_DOSE_COUNT / nswPopulation) * 100,
  );

  d.AIR_VIC_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_VIC_18_PLUS_THIRD_DOSE_COUNT / vicPopulation) * 100,
  );

  d.AIR_QLD_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_QLD_18_PLUS_THIRD_DOSE_COUNT / qldPopulation) * 100,
  );

  d.AIR_SA_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_SA_18_PLUS_THIRD_DOSE_COUNT / saPopulation) * 100,
  );

  d.AIR_WA_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_WA_18_PLUS_THIRD_DOSE_COUNT / waPopulaiton) * 100,
  );

  d.AIR_TAS_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_TAS_18_PLUS_THIRD_DOSE_COUNT / tasPopulation) * 100,
  );

  d.AIR_NT_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_NT_18_PLUS_THIRD_DOSE_COUNT / ntPopulation) * 100,
  );

  d.AIR_ACT_18_PLUS_THIRD_DOSE_PERC = round(
    (d.AIR_ACT_18_PLUS_THIRD_DOSE_COUNT / actPopulation) * 100,
  );

  return d;

  /*

  "AIR_NSW_18_PLUS_THIRD_DOSE_COUNT": 1377173,
  "AIR_VIC_18_PLUS_THIRD_DOSE_COUNT": 1047117,
  "AIR_QLD_18_PLUS_THIRD_DOSE_COUNT": 795101,
  "AIR_WA_18_PLUS_THIRD_DOSE_COUNT": 351938,
  "AIR_TAS_18_PLUS_THIRD_DOSE_COUNT": 93258,
  "AIR_SA_18_PLUS_THIRD_DOSE_COUNT": 299773,
  "AIR_ACT_18_PLUS_THIRD_DOSE_COUNT": 87700,
  "AIR_NT_18_PLUS_THIRD_DOSE_COUNT": 35404,


  // https://www.abs.gov.au/statistics/people/population/national-state-and-territory-population/dec-2020#states-and-territories

  
  const ausPopulation = 25694400;
  const nswPopulation = 8172500;
  const vicPopulation = 6661700;
  const qldPopulation = 5194900;
  const saPopulation = 1770800;
  const waPopulaiton = 2670200;
  const tasPopulation = 541500;
  const ntPopulation = 246600;
  const actPopulation = 431500;

  d.APPROX_AUS_SECOND_DOSE_TOTAL =
    d.APPROX_ACT_SECOND_DOSE_TOTAL +
    d.APPROX_NSW_SECOND_DOSE_TOTAL +
    d.APPROX_NT_SECOND_DOSE_TOTAL +
    d.APPROX_QLD_SECOND_DOSE_TOTAL +
    d.APPROX_SA_SECOND_DOSE_TOTAL +
    d.APPROX_TAS_SECOND_DOSE_TOTAL +
    d.APPROX_VIC_SECOND_DOSE_TOTAL +
    d.APPROX_WA_SECOND_DOSE_TOTAL;

  function round(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  d.APPROX_AUS_SECOND_DOSE_PERC = round(
    (d.APPROX_AUS_SECOND_DOSE_TOTAL / ausPopulation) * 100,
  );
  d.APPROX_NSW_SECOND_DOSE_PERC = round(
    (d.APPROX_NSW_SECOND_DOSE_TOTAL / nswPopulation) * 100,
  );
  d.APPROX_VIC_SECOND_DOSE_PERC = round(
    (d.APPROX_VIC_SECOND_DOSE_TOTAL / vicPopulation) * 100,
  );
  d.APPROX_QLD_SECOND_DOSE_PERC = round(
    (d.APPROX_QLD_SECOND_DOSE_TOTAL / qldPopulation) * 100,
  );
  d.APPROX_SA_SECOND_DOSE_PERC = round(
    (d.APPROX_SA_SECOND_DOSE_TOTAL / saPopulation) * 100,
  );
  d.APPROX_WA_SECOND_DOSE_PERC = round(
    (d.APPROX_WA_SECOND_DOSE_TOTAL / waPopulaiton) * 100,
  );
  d.APPROX_TAS_SECOND_DOSE_PERC = round(
    (d.APPROX_TAS_SECOND_DOSE_TOTAL / tasPopulation) * 100,
  );
  d.APPROX_NT_SECOND_DOSE_PERC = round(
    (d.APPROX_NT_SECOND_DOSE_TOTAL / ntPopulation) * 100,
  );
  d.APPROX_ACT_SECOND_DOSE_PERC = round(
    (d.APPROX_ACT_SECOND_DOSE_TOTAL / actPopulation) * 100,
  );

  return d;
  */
}
